import dayjs from "dayjs";
import millify from "millify";
import GeoJSON from "ol/format/GeoJSON";
import { Fill, Stroke, Style } from "ol/style";

export function getDateRangeFromIsoStrings(start, end) {
    return `${dayjs(start).format("MMMM D, YYYY")} to ${dayjs(end).format("MMMM D, YYYY")}`;
}

export function getRoundingFactorFromNumber(number) {
    let roundingFactor;

    if (number < 10000) {
        roundingFactor = 1000;
    } else if (number < 1000000) {
        roundingFactor = 100000;
    } else if (number < 10000000) {
        roundingFactor = 1000000;
    } else if (number < 100000000) {
        roundingFactor = 10000000;
    } else {
        roundingFactor = 100000000;
    }
    return Math.ceil(number / roundingFactor) * roundingFactor;
}

export function getLegendIntervalFromSubmissionAndType(submission, type) {
    const features = new GeoJSON().readFeatures(submission.report_json.heatmap_geojson);

    // calculate max value in the dataset
    let maxValue = Number.MIN_SAFE_INTEGER;
    features.forEach((feature) => {
        const properties = feature.getProperties();

        const stats = properties.heatmap_stats.find(({ name }) => {
            return name === type;
        });
        if (stats && isNaN(stats.value) === false && stats.value > maxValue) {
            maxValue = stats.value;
        }
    });
    if (maxValue !== Number.MIN_SAFE_INTEGER) {
        return getRoundingFactorFromNumber(maxValue);
    } else {
        return 1000;
    }
}

export function getFeaturesFromSubmissionAndType(submission, type) {
    const features = new GeoJSON().readFeatures(submission.report_json.heatmap_geojson);

    // calculate max value in the dataset
    let maxValue = Number.MIN_SAFE_INTEGER;
    features.forEach((feature) => {
        const properties = feature.getProperties();

        const stats = properties.heatmap_stats.find(({ name }) => {
            return name === type;
        });
        if (stats && isNaN(stats.value) === false && stats.value > maxValue) {
            maxValue = stats.value;
        }
    });

    // apply the proper style
    const roundingFactor = getRoundingFactorFromNumber(maxValue);
    features.forEach((feature) => {
        const properties = feature.getProperties();

        let style = new Style({
            stroke: new Stroke({ color: "black", width: 1 }),
            fill: new Fill({ color: "rgba(128, 128, 128, 0.5)" })
        });
        const stats = properties.heatmap_stats.find(({ name }) => {
            return name === type;
        });
        if (stats && isNaN(stats.value) === false) {
            const opacity = Math.round((stats.value / roundingFactor) * 10) / 10;
            style = new Style({
                stroke: new Stroke({ color: "black", width: 1 }),
                fill: new Fill({ color: `rgba(255, 0, 0, ${opacity})` })
            });
        }
        feature.setStyle(style);
    });

    // filter out features
    const filteredFeatures = features.filter((feature) => {
        const properties = feature.getProperties();
        const stats = properties.heatmap_stats.find(({ name }) => {
            return name === type;
        });
        if (stats && isNaN(stats.value) === false) {
            return true;
        } else {
            return false;
        }
    });
    return filteredFeatures;
}

export function getMapLegendFromSubmission(selectedPreviousSubmission, title) {
    const interval = getLegendIntervalFromSubmissionAndType(selectedPreviousSubmission, title);

    return [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1].map((value) => {
        return { value: millify(interval * value), color: `rgba(255, 0, 0, ${value})` };
    });
}
